import { render, staticRenderFns } from "./CoordenadasNew.vue?vue&type=template&id=e09f1e4c&scoped=true"
import script from "./CoordenadasNew.vue?vue&type=script&lang=js"
export * from "./CoordenadasNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09f1e4c",
  null
  
)

export default component.exports